import { constantsData, formFieldNamesData } from "@/data";
import { InputTypeEnum } from "@/enums";

const {
    confirmPassword,
    email,
    fullName,
    password,
} = constantsData.forms.auth.verifyAccount;

const {
    confirmPassword: confirmPasswordFieldName,
    email: emailFieldName,
    fullName: fullNameFieldName,
    password: passwordFieldName,
} = formFieldNamesData;

export const verifyAccountFormData = [
    {
        isDisabled: true,
        label: fullName.label,
        name: fullNameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        isDisabled: true,
        label: email.label,
        name: emailFieldName,
        type: InputTypeEnum.EMAIL,
    },
    {
        label: password.label,
        name: passwordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
    {
        label: confirmPassword.label,
        name: confirmPasswordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
];
